import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=6ef85020&scoped=true"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"
import style0 from "./SendEmail.vue?vue&type=style&index=0&id=6ef85020&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef85020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef85020')) {
      api.createRecord('6ef85020', component.options)
    } else {
      api.reload('6ef85020', component.options)
    }
    module.hot.accept("./SendEmail.vue?vue&type=template&id=6ef85020&scoped=true", function () {
      api.rerender('6ef85020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/SendEmail.vue"
export default component.exports